import React from "react";
import { Table } from "antd";
import { ExternalOrderInfo } from "@api/throughShipment/throughShipmentApi";
import { Row, RowContent, NormalTitle, Title } from "./style";

type Props = {
  externalOrderInfo: ExternalOrderInfo;
};

export default function OrderDeductionSection({ externalOrderInfo }: Props) {
  const Columns = [
    { key: "name", dataIndex: "name", title: "項目名稱", width: 100 },
    {
      key: "rate",
      dataIndex: "rate",
      title: "項目抽成",
      width: 100,
      render: (rate: number | null | undefined) => <div>{!rate ? "-" : `${rate}%`}</div>,
    },
    {
      key: "amount",
      dataIndex: "amount",
      title: "項目費用",
      width: 100,
      render: (amount: number | null | undefined) => <div>{!amount ? "-" : `${amount}`}</div>,
    },
  ];

  return (
    <>
      <Title>商品後扣抽成項目</Title>
      <Row marginTop="20px" align="flex-start">
        <NormalTitle>後扣項目</NormalTitle>
        <RowContent width={500}>
          <Table columns={Columns} dataSource={[externalOrderInfo?.orderDeduction]} pagination={false} bordered />
        </RowContent>
      </Row>
      <Row marginTop="20px" align="flex-start">
        <NormalTitle>訂單費用</NormalTitle>
        <RowContent width={500}>
          <Table columns={Columns} dataSource={externalOrderInfo.orderFee} pagination={false} bordered />
        </RowContent>
      </Row>
    </>
  );
}
